class OpenEnquiriesController {
  constructor(authService, userService, loadingService, $scope) {
    "ngInject";

    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;
    
    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };        

    this.overrideUserId = null;
    this.enquiries = [];

    $scope.$on('dashboard:viewOpenEnquiriesStats', this.loadStats.bind(this));
    $scope.$on('dashboard:viewOpenEnquiries', this.viewOpenEnquiries.bind(this));
  }

  loadStats(evt, params) {    
    const ctrl = this;

    ctrl.loadingService.showLoading('enquiryList', 'Loading Enquiries');
    
    this.overrideUserId = params ? params.userId : null;

    ctrl.userService.openEnquiriesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId)
      .then(response => {
        ctrl.pagination.totalItems = response.data;
        ctrl.onLoadStats({count: response.data});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('enquiryList');
      });
  }  

  viewOpenEnquiries(evt, params) {
    //Toggle Event coming from dashboard instead of page change, skip the method
    if (evt && this.enquiries.length && !params.reload){
      return;
    }

    const ctrl = this;

    ctrl.loadingService.showLoading('enquiryList', 'Loading Enquiries');

    ctrl.userService.openEnquiries(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.pagination.currentPage)
      .then(response => {
        ctrl.enquiries = response.data;
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('enquiryList');
      });
  } 
}

export default OpenEnquiriesController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/openEnquiries/openEnquiries.controller.js